import React from 'react';
import NowName from '../shared/NowName';
import SplitList from './SplitList';

/**
 * A list of companies (Companies / Companies Covered on the detail pages) —
 * one framed row each, the SplitList look: the name (with "(now: …)" after a
 * rename), its UEN underneath, and an optional link or badge on the right.
 *
 *   entities   [{ id?, entityId?, entityName, entityNameNow?, uen, uenNow? }]
 *   controlOf  (entity) => node for the right-hand side, or null
 */
const CompanyList = ({ entities = [], controlOf = () => null }) => (
  <SplitList
    controlClass="shrink-0"
    rows={entities.map((e, i) => ({
      key: e.id || `${e.entityId || 'entity'}-${i}`,
      title: <NowName value={e.entityName} now={e.entityNameNow} />,
      subtitle: <>UEN <NowName value={e.uen || '—'} now={e.uenNow} /></>,
      control: controlOf(e),
    }))}
  />
);

export default CompanyList;
